import './style.css'
import * as A from './addons'
import * as C from './components'
import * as T from './types'

const NotificationVariant = {
  Mention: T.Mention,
  Comments: T.Comments,
  Status: T.Status,
  OperatorShiftCanceled: T.OperatorShiftCanceled,
  ShiftDemotion: T.ShiftDemotion,
  ShiftReplaced: T.ShiftReplaced,
  ShiftReplacementCanceled: T.ShiftReplacementCanceled,
  Engagement: T.Engagement,
  ProgramUpdated: T.ProgramUpdated,
  ProgramPerformanceAccuracy: T.ProgramPerformanceAccuracy,
  WorkforceDemandMS: T.WorkforceDemandMS,
  TrainingComplete: T.TrainingComplete,
  SpecialistIneligible: T.SpecialistIneligible,
  SopUpdated: T.SopUpdated,
  TokenExpiration: T.TokenExpiration,
  NewEngagement: T.NewEngagement,
  ReplyComment: T.ReplyComment,
  CommentThread: T.CommentThread,
  Like: T.Like,
  TrainingInvitation: T.TrainingInvitation,
  TrainingInvitationReminder: T.TrainingInvitationReminder,
  EligibilitySuspended: T.EligibilitySuspended,
  EligibilityEnabled: T.EligibilityEnabled,
  SuspensionStarted: T.SuspensionStarted,
  SuspensionEnded: T.SuspensionEnded,
  SuspensionRequalified: T.SuspensionRequalified,
  EligibilityRemoved: T.EligibilityRemoved,
  TrainingReset: T.TrainingReset,
  TrainingRemoved: T.TrainingRemoved,
} as const

export const Notification = {
  Group: C.NotificationGroup,
  Variant: NotificationVariant,
  Item: C.NotificationItem,
  Modal: C.NotificationModal,
  Addon: {
    Dot: A.Dot,
    Avatar: A.Avatar,
  },
} as const

export const NotificationComponents = {
  mention: Notification.Variant.Mention,
  comment: Notification.Variant.Comments,
  status: Notification.Variant.Status,
  engagement: Notification.Variant.Engagement,
  operator_shift_cancelled: Notification.Variant.OperatorShiftCanceled,
  shift_demotion: Notification.Variant.ShiftDemotion,
  shift_replaced: Notification.Variant.ShiftReplaced,
  shift_replacement_cancelled: Notification.Variant.ShiftReplacementCanceled,
  'specialist-ineligible': Notification.Variant.SpecialistIneligible,
  'training-complete': Notification.Variant.TrainingComplete,
  'workforce-demand-ms': Notification.Variant.WorkforceDemandMS,
  'program-performance-accuracy': Notification.Variant.ProgramPerformanceAccuracy,
  'program-updated': Notification.Variant.ProgramUpdated,
  'comment-thread': Notification.Variant.CommentThread,
  'new-engagement': Notification.Variant.NewEngagement,
  'reply-comment': Notification.Variant.ReplyComment,
  'sop-updated': Notification.Variant.SopUpdated,
  'token-expiration': Notification.Variant.TokenExpiration,
  like: Notification.Variant.Like,
  training_invitation: Notification.Variant.TrainingInvitation,
  training_invitation_reminder: Notification.Variant.TrainingInvitationReminder,
  eligibility_suspended: Notification.Variant.EligibilitySuspended,
  eligibility_enabled: Notification.Variant.EligibilityEnabled,
  suspension_started: Notification.Variant.SuspensionStarted,
  suspension_ended: Notification.Variant.SuspensionEnded,
  suspension_requalified: Notification.Variant.SuspensionRequalified,
  eligibility_removed: Notification.Variant.EligibilityRemoved,
  training_reset: Notification.Variant.TrainingReset,
  training_removed: Notification.Variant.TrainingRemoved,
} as {
  [key: string]: React.FC<NotificationTypeProps>
}

export type NotificationTypeProps =
  | T.WorkforceDemandMSProps
  | T.ProgramUpdatedProps
  | T.TrainingCompleteProps
  | T.SpecialistIneligibleProps
  | T.OperatorShiftCanceledProps
  | T.ShiftDemotionProps
  | T.ShiftReplacedProps
  | T.ShiftReplacementCanceledProps
  | T.StatusProps
  | T.ProgramPerformanceAccuracyProps
  | T.MentionProps
  | T.EngagementProps
  | T.CommentProps
  | T.SopUpdatedProps
  | T.TokenExpirationProps
  | T.NewEngagementProps
  | T.ReplyCommentProps
  | T.CommentThreadProps
  | T.LikeProps
  | T.TrainingInvitationProps
  | T.TrainingInvitationReminderProps
  | T.EligibilitySuspendedProps
  | T.EligibilityEnabledProps
  | T.SuspensionStartedProps
  | T.SuspensionEndedProps
  | T.SuspensionRequalifiedProps
  | T.EligibilityRemovedProps
  | T.TrainingResetProps
  | T.TrainingRemovedProps
